module.exports = __webpack_public_path__ + "img/Xingqi_Chen.b26bf4b4.png";